import type { ReactNode } from 'react'

export function ListHeader({ children }: { children: ReactNode }): ReactNode {
  return (
    <div className="flex items-center gap-2 border-b-[0.5px] px-pagex-default py-2 lg:px-pagex-lg print:hidden">
      {children}
    </div>
  )
}
